import { ICreateSection } from '../../section/types';

export const SECTION_FORM_INITIAL_STATE: ICreateSection = {
  title: '',
  system: '',
};
